import React, { useState } from "react"

import Modal from "@/components/core/Modal/Modal"
import AddressForm from "@/components/AccountSettings/v1/AddressForm"

import {
  addAnalyticsForAddAddresses,
  addDataLayerEditAddressClose,
} from "@/components/AccountSettings/v1/Addresses/analytics"

const AddressTile = ({
  id = "",
  i18n = {},
  data = {},
  onDelete = () => {},
  onEdit = () => {},
  stateData = [],
  country = "",
  countries = [],
  isDefault = false,
  onCloseRef = {},
  ...props
}) => {
  const [showEdit, setShowEdit] = useState(false)
  const [editDataFormat, seteditDataFormat] = useState({})
  const closeForm = () => {
    setShowEdit(false)
    addDataLayerEditAddressClose()
  }

  const handleEditAddress = (e, editAddress) => {
    window.preActiveElement = e.target
    const address = {
      firstName: { value: editAddress?.firstName ?? "" },
      lastName: { value: editAddress?.lastName ?? "" },
      address1: { value: editAddress?.streetName ?? "" },
      address2: { value: editAddress?.streetNumber ?? "" },
      city: { value: editAddress?.city ?? "" },
      state: { value: editAddress?.state ?? "" },
      zipcode: { value: editAddress?.postalCode ?? "" },
      country: { value: editAddress?.country ?? "" },
      addresstypes: { value: editAddress?.custom?.fields?.label ?? "" },
      edit: true,
      phone: { value: editAddress?.phone ?? "" },
    }
    seteditDataFormat(address)
    setShowEdit(true)
    addAnalyticsForAddAddresses("edit")
  }

  const handleDeleteAddress = (e, data) => {
    window.preActiveElement = document.getElementById("kf-add-address-btn")
    onDelete(data?.id)
    addAnalyticsForAddAddresses("delete")
  }
  const handleSubmitEditAddress = (data, abbr) => {
    const obj = {
      city: abbr?.city?.value,
      country: "US",
      custom: {
        fields: { label: abbr?.addresstypes?.value },
        type: {
          typeId: "type",
          key: "custom-address",
        },
      },
      email: data?.email,
      firstName: abbr?.firstName?.value,
      lastName: abbr?.lastName?.value,
      phone: abbr?.phone?.value,
      postalCode: abbr?.zipcode?.value,
      state: abbr?.state?.value,
      streetName: abbr?.address1?.value,
      streetNumber: abbr?.address2?.value,
      setPrimary: abbr?.label?.show,
    }
    closeForm()
    onEdit(data?.id, obj)
  }
  return (
    <React.Fragment>
      <div
        id={id}
        className="account-address-tile custom-label-edit"
        role="listitem"
      >
        <div className="account-address-tile__info">
          {isDefault && (
            <div className="account-address-tile__default">{i18n?.default}</div>
          )}
          <div className="account-address-tile__label">
            {data?.custom?.fields?.label}
          </div>
        </div>
        <div className="account-address-tile__address">
          <div>
            {data?.firstName} {data?.lastName}
          </div>
          <div>
            {data?.streetName}, {data?.streetNumber}
          </div>
          <div>
            {data?.city}, {data?.state} {data?.postalCode}
          </div>
          <div>{data?.phone}</div>
        </div>

        <div className="account-address-tile__cta">
          <div
            role="button"
            tabIndex="0"
            aria-label={i18n?.editAddress}
            onClick={e => handleEditAddress(e, data)}
          >
            {i18n?.edit}
          </div>
          <div
            role="button"
            tabIndex="0"
            aria-label={i18n?.deleteAddress}
            onClick={e => handleDeleteAddress(e, data)}
          >
            {i18n?.delete}
          </div>
        </div>
        <Modal
          showModal={showEdit}
          onModalClose={closeForm}
          modalTitle={i18n?.editAddress}
        >
          <div className="account-address__modal">
            <div className="edit-address__title">
              <span>{i18n?.editAddress}</span>
            </div>
            {showEdit && (
              <AddressForm
                i18n={i18n}
                data={editDataFormat}
                stateData={stateData}
                onEdit={abbr => handleSubmitEditAddress(data, abbr)}
                isDefault={isDefault}
                country={country}
                countries={countries}
                onCloseRef={onCloseRef}
              />
            )}
          </div>
        </Modal>
      </div>
    </React.Fragment>
  )
}
export default AddressTile
